module.exports = __webpack_public_path__ + "img/01-24-165.dc97843c.jpg";